var styles = {
  "Backdrop": "Online-Store-UI-Backdrop_12w2g",
  "show": "Online-Store-UI-Backdrop--show_1txk3",
  "fullscreen": "Online-Store-UI-Backdrop--fullscreen_1lpmb"
};

export { styles as default };
